<template>
  <div>
    <congrats-menu active="Cumpleaños"/>
    <v-layout row wrap>
      <v-flex md1 hidden-xs-only pt-2>
        <div class="fixed-celebration-buttons">
          <v-btn
            v-for="date in dates"
            :key="date"
            :color="date == datePicker ? '#28385C' : 'white'"
            block
            class="btn-primary-security text-14-security"
            :class="date == datePicker ? 'white--text font-weight-bold' : ''"
            @click="changeDatePicker(date)"
          >
            {{date}}
          </v-btn>
        </div>
      </v-flex>
      <v-flex hidden-sm-and-up>
        <v-select
          :items="dates"
          v-model="datePicker"
          label="Fecha"
          outline
          @change="changeDatePicker(datePicker)"
        ></v-select>
      </v-flex>
      <v-flex xs12 md11 :class="{'pt-2 pl-4': $vuetify.breakpoint.mdAndUp}">
        <BirthdayInfinite :date="datePicker" :monthNumber="dates.indexOf(datePicker)" :key="datePicker" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import BirthdayInfinite from "./BirthdayInfinite"
import CongratsMenu from "../General/CongratsMenu"
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  components: {
    BirthdayInfinite,
    CongratsMenu
  },
  data() {
    return {
      page: 1,
      list: [],
      dates: ["hoy","enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      datePicker: "hoy",
      todayMonth: new Date().getMonth()
    };
  },
  methods: {
    changeDatePicker(date){
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.datePicker = date;
    }
  }
};
</script>

<style>
/* Corrige el alineamiento del texto en los botones del listado de cumpleaños en Internet Explorer */
@media all and (-ms-high-contrast:none){
  *::-ms-backdrop, .btn-primary-security .v-btn__content { margin-left: -30px } /* IE11 */
}
</style>
